import { render, staticRenderFns } from "./ImpresionBoletosBlanco.vue?vue&type=template&id=08dbee4a&scoped=true&"
import script from "./ImpresionBoletosBlanco.vue?vue&type=script&lang=js&"
export * from "./ImpresionBoletosBlanco.vue?vue&type=script&lang=js&"
import style0 from "./ImpresionBoletosBlanco.vue?vue&type=style&index=0&id=08dbee4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dbee4a",
  null
  
)

export default component.exports